import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {AnnouncementContainerVo} from '../../common/shared/api/nicolas/vo/AnnouncementContainerVo.interface';
import {AnnouncementTarget} from '../../graphql/generated/types';

const AnnouncementTargetToParamMap: {[key in AnnouncementTarget]: string} = {
  [AnnouncementTarget.Android]: 'android',
  [AnnouncementTarget.Ios]: 'ios',
  [AnnouncementTarget.All]: 'all',
};

export type GetAppHelpListParams = {
  page?: number;
  size?: number;
  target: AnnouncementTarget;
};

/**
 * 도움말 목록 조회
 *
 * Origin: pageNicolasApi.getHelpList
 * API: GET /api/v1/app/help/list
 */
export async function getAppHelpList(
  {page = 0, size = 500, target}: GetAppHelpListParams,
  options?: FetcherOptions
): Promise<AnnouncementContainerVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/app/help/list',
    {
      method: 'GET',
      params: {
        page,
        size,
        target: AnnouncementTargetToParamMap[target],
      },
    },
    options
  );
  return response.data;
}
